import React, { useEffect, useRef, useState } from "react";

const HoverList = ({ options, icon, text }) => {
    const [dropdown, setDropdown] = useState(false);

    const ref = useRef(null);
    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setDropdown(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
    return (
        <div
            className="relative cursor-pointer font-medium text-black dark:text-white"
            onClick={() => {
                setDropdown((dropdown) => !dropdown);
            }}
            ref={ref}
        >
            <div
                className={`flex justify-between items-center w-full input border rounded-full p-2.5 duration-150 ${
                    dropdown
                        ? "border-kadComponentFocus"
                        : "border-kadComponentBorder"
                }`}
            >
                {icon}
                {text}
            </div>
            {dropdown && (
                <div className="absolute right-0 top-12 backdrop-blur-md z-10 animation-fade-in rounded-lg overflow-hidden">
                    {options.map(
                        (el, i) =>
                            el && (
                                <div
                                    key={i}
                                    className="p-4 pr-8 flex gap-2 border-b border-kadComponentBorder last:border-0 items-center bg-kadItemDarkBg hover:bg-kadDarkBg duration-150"
                                    onClick={() => {
                                        el.handler && el.handler(el);
                                    }}
                                >
                                    {el.icon}
                                    <span className="whitespace-nowrap">
                                        {el.text}
                                    </span>
                                </div>
                            )
                    )}
                </div>
            )}
        </div>
    );
};
export default HoverList;
